import React from 'react'
import {renderComponent} from './Layout'
import Section from './Section'
import { Link } from 'react-router-dom'
import { Swipeable, defineSwipe } from 'react-touch';
import {connect} from 'react-redux';
import moment from 'moment';

class PostsSection extends Section {
    constructor(props) {
        super(props)
        this.state = this.state || { page: 1 };
        this.state.activeIndex = 0;
        this.swipable = null;
        this.pageSize = 5;
    }

    componentDidMount() {
        this.props.loadPosts()
    }

    isMobile() {
        return this.container && this.container.getBoundingClientRect().width < 999
    }

    currentPage() {
        if (this.isMobile()) {
            return this.state.page || 1;
        }

        return 1;
    }

    pageCount() {
        return Math.ceil(this.props.posts.length / this.pageSize); 
    }

    prev() {
        if (this.state.activeIndex <= 0) {
            return;
        }

        this.setState({activeIndex: this.state.activeIndex-3})
    }

    next() {
        this.setState({activeIndex:
            this.state.activeIndex+3
        })
    }

    renderPosts(activeIndex, posts, styles, swipe) {
        return <div className="section-content" ref={(e) => this.container = e}>
            <div className="container posts-container">
                    {activeIndex > 0 && (
                    <button className="post-list-left" onClick={() => this.prev()}>
                        <span className="sr-only">Links</span>
                    </button>
                    )}
                    {posts.length > 3 && activeIndex < this.props.posts.length - 3 && (
                    <button className="post-list-right" onClick={() => this.next()}>
                        <span className="sr-only">Rechts</span>
                    </button>
                    )}
                    <div className="post-list" style={styles}>
                    {posts.map((post, i) => (
                        <div key={i} className={i === activeIndex ? "post is-active" : "post"}>
                            <img className="post-image" src={"/cockpit/storage/uploads"+post.image.path} alt={post.title} />
                            <div className="post-date">{moment(post.date).format('DD.MM.YYYY')}</div>
                            <div className="post-title">{post.title}</div>
                            <div className="post-excerpt">
                                <div className="text">{post.intro}</div>
                                <Link to={"/aktuelles/" + post._id + "#top"} className="white-btn">weiter lesen</Link>
                            </div>
                        </div>
                    ))}
                    </div>
                
            </div>
        </div>
    }

    renderPostsContainer(activeIndex, posts, styles, swipe) {
        const pages = []
        for (var i = 1; i <= this.pageCount(); i++) {
            pages.push(i);
        }

        const offset = (this.currentPage()-1)*this.pageSize
        posts = posts.slice(offset, offset+5)

        if (this.isMobile()) {
            return (
                <div className="post-pager">
                    {this.renderPosts(activeIndex, posts, styles, swipe)}
                    <p>
                        {pages.map((i) => (<a className={"post-pager-page" + (i==this.currentPage()?" active":"")} key={i} href="#" onClick={() => this.setState({page: i})}>{i}</a>))}
                    </p>
                </div>
            )
        }

        return (
            <Swipeable config={swipe} onSwipeLeft={() => this.next()} onSwipeRight={() => this.prev()}>
            {this.renderPosts(activeIndex, posts, styles, swipe)}
            </Swipeable>
        )
    }

    render() {
        const props = this.props;
        let activeIndex = this.state.activeIndex;
        const settings = props.settings || {}
        let children = props.children || {}
        const swipe = defineSwipe({swipeDistance: 50});

        const classNames = ['section', 'posts-section']
        classNames.push("on-screen")

        activeIndex = Math.min(activeIndex, props.posts.length - 3);

        if (settings.class) {
            classNames.push(settings.class)
        }

        if (props.className) {
            classNames.push(props.className);
        }

        const posts = this.props.posts || []

        const styles = {
            transform: "translateX(" + (activeIndex * -395) + "px)"
        }

        return (
            <section className={classNames.join(' ')}>
            {this.renderPostsContainer(activeIndex, posts, styles, swipe)}               
            </section>  
        )
    }
}

const mapStateToProps = (state, props) => {
    const postList = []
    for(const key in state.posts) {
        if (key != props.current) {
            postList.push(state.posts[key])
        }        
    }

    return {
        posts: postList
    }
}

const mapDispatchToProps = dispatch => {
    return {
        loadPosts: () => {
            const url = process.env.CMS_HOST + "/cockpit/api/collections/get/posts/?token=97fad245c998bc5e4bec5211e361c6"
            fetch(url)
                .then(r => r.json())
                .then(data => {
                    dispatch({
                        type: 'POSTS_LOADED',
                        data: data,
                    })
                })
                .catch((error) => {
                    console.error(error);
                });
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PostsSection)


// WEBPACK FOOTER //
// ./src/components/PostsSection.js